<template>
  <div>
    <v-simple-table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="disableListScroll"
      >
        <tr
          v-for="swap in list"
          :key="swap.id"
          class="clickable new-tab-link-row"
        >
          <td>
            {{ swap.name }}
            <router-link
              :to="{
                name: 'form.food-swap',
                params: { id: swap.id },
              }"
              class="row-link"
            />
          </td>
          <td width="60%">
            {{ swap.notes }}
            <router-link
              :to="{
                name: 'form.food-swap',
                params: { id: swap.id },
              }"
              class="row-link"
            />
          </td>
        </tr>
      </tbody>

      <table-skeleton-loader v-if="loading" column="2" row />
    </v-simple-table>

    <no-list
      v-if="!list.length && !loading"
      details="No Available Food Swaps"
    />
  </div>
</template>

<script>
import TableSkeletonLoader from '@/components/elements/loaders/TableSkeleton'
import NoList from '@/components/elements/NoList'
import infiniteScroll from 'vue-infinite-scroll'

import { mdiDotsVertical } from '@mdi/js'

export default {
  name: 'FoodListTable',

  components: {
    TableSkeletonLoader,
    NoList,
  },

  directives: {
    infiniteScroll,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      icons: {
        action: mdiDotsVertical,
      },
    }
  },

  computed: {
    disableListScroll() {
      return this.loading || this.meta.current_page >= this.meta.last_page
    },
  },

  methods: {
    loadMore() {
      this.$emit('loadMore', this.meta.current_page + 1)
    },

    showDetails(swap) {
      this.$emit('goTo', swap.id)
    },
  },
}
</script>
